module.exports = __webpack_public_path__ + "static/detect-1655af8afb934293a4f4b43c1b3b5d10.png";